<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex mb-2">
          <ExcelExport
              :dataProp="pendingOrders"
              :columnProp="pendingOrdersHeaders"
              :fileNameProp="'Bekleyen Siparişler ' + formattedDate(new Date(), 'DD-MM-YYYY HH:mm:ss')"
          />
          <PrintPage :divId="'printPendingOrders'"></PrintPage>
        </div>
      </div>
      <b-table
          :items="pendingOrders"
          :fields="purchaseOrderHeaders"
          hover
          responsive
          :per-page="perPage"
          head-row-variant="info"
          table-variant="white"
          :busy="pendingOrdersLoading"
      >
        <template #cell(stockName)="data">
          {{data.item.stockName}}
          <p class="mb-0 fs-6" v-if="data.item.producerCode">
            Üretici Kodu :
            <span class="fw-medium fs-7">{{ data.item.producerCode }}</span>
          </p>
        </template>
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{ scope.loading ? "Lütfen Bekleyin" : noOrderMessage }}
          </h6>
        </template>
        <template #cell(date)="data">
          {{ formattedDate(data.item.date, "DD-MM-YYYY") }}
        </template>
        <template #cell(unitPrice)="data">
          {{ numberConverter(data.item.unitPrice) }}
        </template>
        <template #cell(quantityForAdd)="data">
          <div class="d-flex justify-center">
            <input
                v-model="data.item.remainingQuantity"
                type="number"
                :min="1"
                class="form-control form-control-sm"
                style="width: 60px; height: 32px"
            />
          </div>
        </template>
        <template #cell(add)="data">
          <v-btn
              @click="addPurchaseOrderProducts(data.item,data.item.remainingQuantity)"
              small
              icon
              color="success"
          >
            <v-icon> mdi-basket-plus</v-icon>
          </v-btn>
          <div
              class="d-flex justify-content-center"
          >
          </div>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner
                variant="primary"
                size="lg"
                label="Text Centered"
            ></b-spinner>
          </div>
        </template>
      </b-table>
      <v-btn style="float: right" small color="success" @click="addAllPurchaseOrderProducts"> Tümünü Ekle</v-btn>
    </div>
  </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";
import PrintPage from "@/components/shared/PrintPage.vue";
import ExcelExport from "@/components/shared/ExcelExport.vue";
import {formattedDate} from "@/momentHelper";
import {swalToast} from "@/helpers/swalToast";
import {numberConverter} from "../../../../../../helpers";

export default {
  components: {
    PrintPage,
    ExcelExport
  },
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },

  computed: {
    ...mapState("order", ["pendingOrders", "pendingOrdersHeaders", "pendingOrdersLoading","noOrderMessage","pendingOrdersMetaData"]),
  },
  data() {
    return {
      selectRow: false,
      orderDetailDialog: false,
      orderDetailDialogData: null,
      purchaseOrderDialog: false,
      purchaseOrderHeaders: [
        {
          key: 'date',
          label: 'Tarih',
          sortable: false,
          class: "text-center align-middle",
        },
        {
          key: 'stockCode',
          label: 'Stok Kodu',
          sortable: false,
          class: "text-center align-middle",

        },
        {
          key: 'stockName',
          label: 'Stok Adı',
          sortable: false,
          class: "text-left align-middle",

        },
        {
          key: 'documentNumber',
          label: 'Sipariş No',
          sortable: false,
          class: "text-center align-middle",

        },
        {
          key: 'quantity',
          label: 'Miktar',
          sortable: false,
          class: "text-center align-middle",

        },
        {
          key: 'deliveryQuantity',
          label: 'Teslim Miktarı',
          sortable: false,
          class: "text-center align-middle",

        },
        {
          key: 'remainingQuantity',
          label: 'Kalan Bakiye',
          sortable: false,
          class: "text-center align-middle",

        },
        {
          key: 'currentName',
          label: 'Cari Adı',
          sortable: false,
          class: "text-left align-middle",

        },
        {
          key: 'salesPersonName',
          label: 'Plasiyer Adı',
          sortable: false,
          class: "text-left align-middle",

        },
        {
          key: 'unitPrice',
          label: 'Birim Fiyat',
          sortable: false,
          class: "text-right align-middle",

        },
        {
          key: 'description',
          label: 'Açıklama',
          sortable: false,
          class: "text-left align-middle",

        },
        {
          key: 'quantityForAdd',
          label: 'Adet',
          sortable: false,
          class: "text-center align-middle",
        },
        {
          key: "add",
          label: "Ekle",
          class: "text-center align-middle",
          sortable: false,
        }
      ],
      purchaseOrderProducts: [],
      quantityForAdd: 0,
      purchaseOrderBody: [],
      purchaseOrderBodyForView: [],
    };
  },
  methods: {
    numberConverter,
    ...mapMutations("order",["setPendingOrdersCart","setPendingOrdersCartView"]),
    formattedDate,
    openSiparisDetailDialog() {
      this.orderDetailDialog = true;
    },
    sortChanged(value) {
      value;
    },
    addPurchaseOrderProducts(product,quantity) {
      // let totalAmount = ( parseFloat(product.unitPrice.replace(',','.')) * parseFloat(quantity.replace(',' , '.')) );
      let totalAmount = ( parseFloat(product.unitPrice) * parseFloat(quantity) );
      // let totalAmountView = numberConverter( parseFloat(product.unitPrice.replace(',','.')) * parseFloat(quantity.replace(',' , '.')) );
      let objForAdd = {
        "stockCode": product.stockCode,
        "unitPrice": product.unitPrice,
        "quantity": quantity,
        "description": product.description,
        "pendingOrderNumber" : product.documentNumber,
      }
      let ObjForView = {
        "stockCode": product.stockCode,
        "stockName" : product.stockName,
        "unitPrice": product.unitPrice,
        "quantity": quantity,
        "description": product.description,
        "amount" : totalAmount,
        "unit" : product.unit,
      }
      this.purchaseOrderBodyForView.push(ObjForView);
      this.purchaseOrderBody.push(objForAdd);
      this.setPendingOrdersCartView(this.purchaseOrderBodyForView);
      this.setPendingOrdersCart(this.purchaseOrderBody);
      swalToast.fire({
        icon: 'success',
        text: "Ürün Sepete Eklendi",
        iconColor: 'green',
      });
    },
    addAllPurchaseOrderProducts() {
      this.purchaseOrderBodyForView.push(...this.pendingOrders.map((item) => {
        return {
          "stockCode": item.stockCode,
          "stockName": item.stockName,
          "unitPrice": item.unitPrice,
          "quantity": item.remainingQuantity,
          "description": item.description,
          "amount": (parseFloat(item.unitPrice) * parseFloat(item.remainingQuantity)),
        };
      }));
      this.purchaseOrderBody.push(...this.pendingOrders.map((item) => {
        return {
          "stockCode": item.stockCode,
          "unitPrice": item.unitPrice,
          "quantity": item.remainingQuantity,
          "description": item.description,
          "pendingOrderNumber" : item.documentNumber,
        };
      }));
      this.setPendingOrdersCartView(this.purchaseOrderBodyForView);
      this.setPendingOrdersCart(this.purchaseOrderBody);
      swalToast.fire({
        icon: 'success',
        text: "Bu sayfadaki tüm ürünler sepete eklendi",
        iconColor: 'green',
      });
    }
  },
  watch: {

  },
};
</script>
